module.exports = __webpack_public_path__ + "static/Goosebumps_NoSLogo-f94a4c9e260dacd66a46ef41492d7273.png";